import React, { useEffect, useState } from 'react'
import AssociatePartner from './AssociatePartner'
import AddNewPartner from './AddNewPartner'
import { toast } from 'react-toastify'
import api from '../../utils/api'

const ManageExternalPartnerHome = () => {

    const [serviceNames, setServiceNames] = useState()

    const getServiceNames = () => {
        const { tempServiceNames } = api.serviceNameDropdownData()
            .then(({ data }) => {
                const filteredData = data.filter(item => item.sServiceCode !== null)
                .map(item => ({
                    // label: item.sServiceDisplayName,
                    label: item.sServiceCode,
                    value: item.sServiceCode
                }))
                setServiceNames(filteredData)
            })
    }

    const [selectedServiceNames, setSelectedServiceNames] = useState("")

    const [Tabledata, setTabledata] = useState()

    const serviceList = Tabledata ? Tabledata.sNamesByServiceCode[selectedServiceNames.value] : ""

    console.log("Tbdata", serviceList)

    const onServiceNameChange = (option) => {
        setSelectedServiceNames(option)
        console.log(option)
    }

    const getTableData = () => {
        const { tempTableData } = api.getServiceTableData(selectedServiceNames.value)
            .then(({ data }) => {
                console.log("working", data)
                setTabledata(data)
            })
    }

    useEffect(() => {
        getTableData()
    }, [selectedServiceNames])

    const [data, setData] = useState()
    const [listpartner, setListpartner] = useState()

    const getServicePartnerDropdownList = () => {
        const { tempServicePartner } = api.getServicePartnerDropdownData()
            .then(({ data }) => {
                console.log(data)
                const transformedData = data.map(item => ({ label: item.sName, value: item.sName }));
                setData(data)
                setListpartner(transformedData)
            })
    }

    useEffect(() => {
        getServicePartnerDropdownList()
        getServiceNames()
    }, [])


    const [selectedServicePartnerNames, setSelectedServicePartnerName] = useState("")
    const [selectedServicePartnerNames1, setSelectedServicePartnerName1] = useState("")

    const onServicePartnerNameChange = (option) => {
        setSelectedServicePartnerName(option)
    }

    const onServicePartnerNameChange1 = (option) => {
        setSelectedServicePartnerName1(option)
        console.log(option)
        const newFilterData = data.filter((ele) => ele.sName === option.value)
        console.log(newFilterData[0].sName)
        setServicePartnerFields({
            sServicePartnerEmail: newFilterData[0].sServicePartnerEmail,
            sName: newFilterData[0].sName,
            sServicePartnerOrg: newFilterData[0].sServicePartnerOrg,
            sMobileNumber: newFilterData[0].sMobileNumber
        })
    }

    const associateButton = () => {
        if (selectedServiceNames.value === undefined) {
            toast("Please Select Service Type", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (selectedServicePartnerNames.value === undefined) {
            toast("Please Select Service Partner", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else {
            const partner = data.find((ele) => ele.sName === selectedServicePartnerNames.value);
            const partnerId = partner.id;
            let payload = {
                sServiceCode_list: [selectedServiceNames.value],
            }
            const { tempAssociatePartner } = api.associatePartner(payload, partnerId)
                .then(({ data }) => {
                    console.log("done", data)
                    getTableData()
                    toast("Associated Service Partner", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                })
        }
    }

    const [isNewPartnerBtnClicked, setIsNewPartnerBtnClicked] = useState(false)

    const newPartnerButton = () => {
        setIsNewPartnerBtnClicked(true)
        setServicePartnerFields({
            sServicePartnerEmail: "",
            sName: "",
            sServicePartnerOrg: "",
            sMobileNumber: ""
        })
        setSelectedServicePartnerName1("")
    }

    const onBackClick = () => {
        setIsNewPartnerBtnClicked(false)
        setServicePartnerFields({
            sServicePartnerEmail: "",
            sName: "",
            sServicePartnerOrg: "",
            sMobileNumber: ""
        })
        setSelectedServicePartnerName1("")
    }

    const resetBtn = () => {
        setServicePartnerFields({
            sServicePartnerEmail: "",
            sName: "",
            sServicePartnerOrg: "",
            sMobileNumber: ""
        })
        setSelectedServicePartnerName1("")
    }

    const clearBtn = () => {
        setSelectedServiceNames("")
        setSelectedServicePartnerName("")
    }

    const [servicePartnerFields, setServicePartnerFields] = useState({
        sServicePartnerEmail: "",
        sName: "",
        sServicePartnerOrg: "",
        sMobileNumber: ""
    })

    const handleChange = (name, value) => {
        const updated = { ...servicePartnerFields, [name]: value };
        setServicePartnerFields(updated);

        const {
            sName,
            sServicePartnerEmail,
            sMobileNumber,
            sServicePartnerOrg
        } = updated;
    };

    const onSubmitBtnClick = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileNumberPattern = /^\d{10}$/; 

        if (servicePartnerFields.sName === "") {
            toast("Service Partner Name is required", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (servicePartnerFields.sServicePartnerEmail === "") {
            toast("Service Partner Email is required", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (!emailPattern.test(servicePartnerFields.sServicePartnerEmail)) {
            toast("Invalid email format", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else if (servicePartnerFields.sServicePartnerOrg === "") {
            toast("Service Partner Organisation is required", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (servicePartnerFields.sMobileNumber === "") {
            toast("Service Partner Mobile No. is required", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (!mobileNumberPattern.test(servicePartnerFields.sMobileNumber)) {
            toast("Invalid mobile number format", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
        else {
            let payload = {
                sServicePartnerEmail: servicePartnerFields.sServicePartnerEmail,
                sName: servicePartnerFields.sName,
                sServicePartnerOrg: servicePartnerFields.sServicePartnerOrg,
                sMobileNumber: servicePartnerFields.sMobileNumber
            }
            if (selectedServicePartnerNames1.value) {
                const partner = data.find((ele) => ele.sName === selectedServicePartnerNames1.value);
                const partnerId = partner.id;
                console.log("Pid", partnerId, payload)
                const { tempUpdatePartner } = api.updateServicePartnerDropdownData(payload, partnerId)
                    .then(({ data }) => {
                        if (data.Message === "Partner Details Updated Successfully.") {
                            toast("Partner Updated Successfully", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            })
                        }
                        getServicePartnerDropdownList()
                        getTableData()
                    })
            } else {
                const { tempAddPartner } = api.addServicePartnerDropdownData(payload)
                    .then(({ data }) => {
                        if (data.Message === "Service Partner Added Successfully.") {
                            toast("Partner Added Successfully", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            })
                        }
                        getServicePartnerDropdownList()
                        getTableData()
                    })
                console.log("Added", payload)
            }
            setIsNewPartnerBtnClicked(false)
        }
    }

    const handleDisassociateBtnClick = (name) => {
        console.log(`Button clicked for name: ${name}`);
        const partner = data.find((ele) => ele.sName === name);
        if (partner) {
            const partnerId = partner.id;
            console.log("id", partnerId, selectedServiceNames.value);
        } else {
            console.log("Partner not found!");
        }
    };


    return (
        <div className='mt-3'>
            {
                isNewPartnerBtnClicked ?
                    <AddNewPartner
                        onBackClick={onBackClick}
                        servicePartnerFields={servicePartnerFields}
                        handleChange={handleChange}
                        onSubmitBtnClick={onSubmitBtnClick}
                        servicePartnerOptions={listpartner}
                        onServicePartnerNameChange={onServicePartnerNameChange1}
                        selectedServicePartnerNames={selectedServicePartnerNames1}
                        resetBtn={resetBtn}
                    />
                    :
                    <AssociatePartner
                        serviceOptions={serviceNames}
                        onServiceNameChange={onServiceNameChange}
                        selectedServiceNames={selectedServiceNames}
                        servicePartnerOptions={listpartner}
                        onServicePartnerNameChange={onServicePartnerNameChange}
                        selectedServicePartnerNames={selectedServicePartnerNames}
                        associateButton={associateButton}
                        newPartnerButton={newPartnerButton}
                        clearBtn={clearBtn}
                        serviceList={serviceList}
                        handleDisassociateBtnClick={handleDisassociateBtnClick}
                        partnerList={data}
                        getTableData={getTableData}
                    />
            }
        </div>
    )
}

export default ManageExternalPartnerHome
